import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { setupAutoSync } from "./lib/syncService";
import { ThemeProvider } from "./providers/ThemeProvider";
import logger from "./lib/logger";

// Set up automatic sync when connection is restored
setupAutoSync();

// Register service worker + AUTO-UPDATE: recarga la página en cuanto se activa
// una versión nueva (evita quedarse con el bundle viejo cacheado).
if ('serviceWorker' in navigator) {
  let refreshing = false;
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshing) return;
    refreshing = true;
    logger.log('Nueva versión activada — recargando');
    window.location.reload();
  });

  navigator.serviceWorker.register('/sw.js').then((registration) => {
    logger.log('Service Worker registered:', registration);

    // Si hay un SW en espera, aplicarlo ya
    if (registration.waiting) {
      registration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }

    // Detectar nuevas versiones e instalarlas
    registration.addEventListener('updatefound', () => {
      const nw = registration.installing;
      if (!nw) return;
      nw.addEventListener('statechange', () => {
        if (nw.state === 'installed' && navigator.serviceWorker.controller) {
          // Nueva versión disponible → activarla (skipWaiting está activo en el sw)
          nw.postMessage({ type: 'SKIP_WAITING' });
        }
      });
    });

    // Comprobar actualizaciones periódicamente y al volver a la pestaña
    const checkUpdate = () => registration.update().catch(() => {});
    setInterval(checkUpdate, 60 * 1000);
    document.addEventListener('visibilitychange', () => {
      if (document.visibilityState === 'visible') checkUpdate();
    });
  }).catch((error) => {
    logger.error('Service Worker registration failed:', error);
  });
}

createRoot(document.getElementById("root")!).render(
  <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
    <App />
  </ThemeProvider>
);
